import { useEffect, useState } from 'react'
import { BooksitoutServer } from '../../../config/BooksitoutServer'
import BookPublisherResponse from './BookPublisherResponse'
import BookIsbnResponse from '../isbn/BookIsbnResponse'
import Paging from '../../../common/hooks/Paging'

const useBookPublisher = (urlName: string | null, size: number = 50) => {
	const [data, setData] = useState<BookPublisherResponse | null>(null)
	const [books, setBooks] = useState<BookIsbnResponse[]>([])
	const [isLoading, setIsLoading] = useState(true)
	const [isError, setIsError] = useState(false)
	const [page, setPage] = useState(0)
	const [isLast, setIsLast] = useState(false)
	const [totalPages, setTotalPages] = useState(0)

	useEffect(() => {
		if (urlName == null || isLast) return

		const isFirstPage = page === 0
		if (isFirstPage) setIsLoading(true)

		BooksitoutServer
			.get(`/v1/book-publisher/${urlName}?page=${page}&size=${size}`)
			.then(res => {
				const response = res.data as BookPublisherResponse
				setData(response)
				setBooks(prev => [...prev, ...response.books.contents])
				setIsLast(response.books.isLast)
				setTotalPages(response.books.totalPages)
			})
			.catch(() => setIsError(true))
			.finally(() => setIsLoading(false))
	}, [urlName, page, size, isLast])

	const paging: Paging = {
		hasMore: !isLast,
		totalPages,
		fetchNext: () => setPage(p => p + 1),
	}

	return [data, books, isLoading, isError, paging] as const
}

export default useBookPublisher
